import styled from 'styled-components';
import { CaptionRegularM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

export const AddParticipantFormCont = styled.form`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.centy}; 
`}
`;

interface IFormPartCell {
  theme: ITheme;
  apiError?: boolean;
  type?: 'email';
}

export const OuterCellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormPartCell = styled.div<IFormPartCell>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 303px;
  ${({ theme, apiError, type }: IFormPartCell) => `
    padding: 0 0 ${theme.layout.spacing.mili} 0;
  `}
`;

export const ControllerCont = styled.div`
  position: relative;
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  left: 5px;
`;

export const AdditionalLabel = styled(CaptionRegularM)`
  position: absolute;
  right: 18px;
  ${({ theme }: IThemeProvider) => `
            color: ${theme.colors.neutral.primary[50]};
        `}
`;
